import { render, staticRenderFns } from "./FailureModal.vue?vue&type=template&id=4dbdb30c&scoped=true"
import script from "./FailureModal.vue?vue&type=script&lang=js"
export * from "./FailureModal.vue?vue&type=script&lang=js"
import style0 from "./FailureModal.vue?vue&type=style&index=0&id=4dbdb30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbdb30c",
  null
  
)

export default component.exports